import { HeaderToolbar } from "@xola/ui-kit";
import React, { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import { useSearchAutoFocus } from "../../hooks/useSearchAutoFocus";

interface ExperienceSearchProps {
    onSearch: (value: string) => void;
}

export const ExperienceSearch = ({ onSearch }: ExperienceSearchProps) => {
    const shouldAutoFocus = useSearchAutoFocus();
    const [search, setSearch] = useState("");
    const [debouncedSearch] = useDebounce(search.trim(), 500);

    useEffect(() => {
        onSearch(debouncedSearch);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedSearch]);

    // Cleaning up on component unmount
    useEffect(() => {
        return () => {
            setSearch("");
        };
    }, []);

    return (
        <span className="relative w-full flex-1">
            <HeaderToolbar.Search
                shouldHideMenu
                autoFocus={shouldAutoFocus}
                shouldStayOpen={false}
                placeholder="Search by name"
                onChange={setSearch}
            />
        </span>
    );
};
